import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { browserHistory, withRouter } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import _ from 'lodash';

const propTypes = {
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  box: PropTypes.object,
};

class EditBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        name: null,
        length: null,
        width: null,
        height: null,
        boxWeight: null,
        weightLimit: null,
        weightAvailable: null,
      },
      box: {
        sequence: '',
        name: '',
        length: '',
        width: '',
        height: '',
        boxWeight: '',
        weightLimit: '',
        weightAvailable: '',
        approved: false,
      },
      open: false,
      edited: false,
      viewRedirect: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.box !== nextProps.box) {
      this.setState({box: nextProps.box})
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const { box } = this.props
    const { required } = this.state
    Object.keys(required).forEach((paramName) => {
      const param = box[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleDeleteOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Delete Box';
    nextState.dialogMessage = 'Do you really want to delete this box?';
    nextState.dialogActionTitle = 'Delete';
    nextState.open = true;
    nextState.delete = true;
    this.setState({ nextState });
  }
  handleChange(e) {
    const nextState = this.state.box;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    nextState.weightAvailable = nextState.weightLimit - nextState.boxWeight
    this.setState({
      box: nextState,
    });
    this.setRequiredParams();
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      browserHistory.push('/boxes');
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Box Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this box rate?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.state.box);
        break;
      default:
        this.props.onSave(this.state.box);
        break;
    }
  }
  handleCancel() {
    browserHistory.push('/boxes');
  }
  render() {
    const { box, required } = this.state
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div>
        <div>
          <DialogModal
            dialogOpen={this.state.open}
            dialogHandleClose={this.handleClose}
            dialogHandleSubmit={() => this.saveChanges()}
            dialogTitle={this.state.dialogTitle}
            dialogMessage={this.state.dialogMessage}
            dialogActionTitle={this.state.dialogActionTitle}
          />
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ marginRight: '10px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              style={{ marginRight: '10px' }}
              label="Delete"
              primary
              onClick={this.handleDeleteOpen}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleOpen}
            />
          </div>
          <br />
          <TextField
              floatingLabelText="Sequence"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={box.sequence}
              name="sequence"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.sequence}
              errorStyle={{ color: cyan500 }}
            />
          <TextField
              floatingLabelText="Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={box.name}
              name="name"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.name}
              errorStyle={{ color: cyan500 }}
            />
            <TextField
              floatingLabelText="Length"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={box.length}
              name="length"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.length}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <TextField
              floatingLabelText="Width"
              floatingLabelStyle={styles.floatingLabelStyle}
              type="number"
              value={box.width}
              name="width"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.width}
              errorStyle={{ color: cyan500 }}
            />
            <TextField
              floatingLabelText="Height"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={box.height}
              name="height"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.height}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <TextField
              floatingLabelText="Box weight"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={box.boxWeight}
              name="boxWeight"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.boxWeight}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <TextField
              floatingLabelText="Weight Limit"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={box.weightLimit}
              name="weightLimit"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.weightLimit}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <TextField
              floatingLabelText="Weight Available"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={box.weightAvailable}
              name="weightAvailable"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.weightAvailable}
              errorStyle={{ color: cyan500 }}
              type="number"
              disabled
            />
            <br /><br /><br />
            <Checkbox
              label="Approved"
              defaultChecked={box.approved}
              name="approved"
              onCheck={this.handleChange}
              />
        </div>
      </div>
    );
  }
}

EditBox.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditBox.propTypes = propTypes;

function mapStateToProps(state) {
  return { 

  };
}

export default connect(mapStateToProps)(EditBox);



// WEBPACK FOOTER //
// ./src/components/boxes/EditBox.js